import { Component } from 'react';
import classNames from 'classnames';
import * as Modal from 'react-modal';
import { t } from 'ttag';

// icons
import VideoCameraIcon from '@svg/video-camera.svg';

// styles
import s from './YoutubeButton.sss';

// types
type YoutubeButtonProps = {
  className?: string;
  videoId: string;
};

type YoutubeButtonStates = {
  open: boolean;
};

export class YoutubeButton
  extends Component<YoutubeButtonProps, YoutubeButtonStates> {

  public state = {
    open: false,
  };

  public handleButtonClick = () => {
    this.setState({ open: true });
  };

  public handleCloseClick = () => {
    this.setState({ open: false });
  };

  public render() {
    const { className, videoId } = this.props;
    const iframe = `<iframe
      type="text/html"
      width="640"
      height="360"
      src="https://www.youtube.com/embed/${videoId}?modestbranding=1&autohide=1&showinfo=0&autoplay=1"
      frameBorder="0"
      allowFullScreen
    />`;

    return (
      (
        <div className={classNames(s.root, className)}>
          {/* TODO: Fix this the next time the file is edited. */}
          <a
            role="button"
            className={s.button}
            onClick={this.handleButtonClick}
          >
            <VideoCameraIcon
              className={s.icon}
              width='30'
              height='30'
            />
            {t`Відео огляд`}
          </a>
          <Modal
            isOpen={this.state.open}
            onRequestClose={this.handleCloseClick}
            className={s.modal}
            overlayClassName={s.modelBackground}
          >
            <div
              className={s.iframeWrapper}
             
              dangerouslySetInnerHTML={{ __html: iframe }}
            />
          </Modal>
        </div>
      )
    );
  }
}

export default YoutubeButton;
